import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'gold';
  fullWidth?: boolean;
  showIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  showIcon = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold tracking-wide uppercase transition-all duration-300 rounded-sm overflow-hidden group';
  const variants = {
    primary: 'bg-terracotta text-white shadow-premium hover:shadow-premium-hover hover:bg-terracotta-dark',
    gold: 'bg-gold text-white shadow-lg hover:bg-yellow-600'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-205">
      <span className="relative z-10 flex items-center gap-2" data-id="element-206">
        {children}
        {showIcon && <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-207" />}
      </span>
      <div className="absolute inset-0 h-full w-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-208" />
    </motion.button>;
}